// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LaiAa","comment":"styles_comment__107cu"};